module.exports = __webpack_public_path__ + "static/profile_picture_destroyed_eyes-17bcf07953a5fda1d12af6021c4821e2.png";